// Cliente Supabase único (auth + PostgREST + Edge Functions).
// Usado SÓ no modo profissional/cloud — o modo família segue 100% local (Dexie),
// sem tocar nada disto. A sessão persiste no localStorage (autoRefresh).
import { createClient } from "@supabase/supabase-js";
import { SUPABASE_ANON_KEY, SUPABASE_URL } from "./env";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // pega tokens de magic-link/convite no retorno
    flowType: "pkce",
  },
});
